/**
 * ODM Portal Frontend Configuration
 * Automatically detects environment based on hostname and loads appropriate config
 */

// Smart environment detection based on hostname
const detectEnvironment = () => {
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }

  // UAT environment
  if (hostname.includes('odm-uat') || hostname.includes('acai-odm-uat')) {
    return 'uat';
  }

  // PROD environment - detect by custom domain or Azure default URL pattern
  if (hostname.includes('odm.allianz.com') || hostname.includes('odm-portal-dwc0f5g0fgfjb4h2')) {
    return 'prod';
  }

  // Default to local if unknown (safety fallback)
  console.warn('⚠️ Unknown hostname, defaulting to local config');
  return 'local';
};

// Get current environment
const environment = detectEnvironment();
console.log(`🌍 ODM Portal loading in '${environment}' environment`);

// Import the correct config file based on environment
let config;
if (environment === 'local') {
  config = require('./config/config.local').config;
} else if (environment === 'uat') {
  config = require('./config/config.uat').config;
} else if (environment === 'prod') {
  config = require('./config/config.prod').config;
}

console.log(`✅ Configuration loaded successfully`);

// Export config and environment
export default config;
export { environment };
